require('./src/interaction');
require('./src/locomotion');
/*require('./src/misc');
require('./src/pathfinding');
require('./src/primitives');
*/